const PGAdapter = require('../../common/pg-adapter')

const DATABASE = 'avocado.data_organisation'
const COLUMNS = [
  'id',
  'name',
  'phone_number',
  'email_addresses',
  'country',
  'state',
  'lga',
  'city',
  'street',
  'type',
  'status',
  'category',
  'owning_organisation_id',
  'created_at',
  'updated_at'
]

const columnPreparers = {
  name: (key, value) => {
    return [{
      statement: `UPPER("${key}") = UPPER(%INDEX%)`,
      value
    }]
  }
}

class OrganisationPGAdapter extends PGAdapter {
  constructor (logger, pgConnection, username) {
    super(
      pgConnection,
      DATABASE,
      username,
      COLUMNS,
      'id',
      columnPreparers,
      logger
    )
  }

  async getList (filter = {}) {
    const { results } = await super.getList(filter)
    return results
  }
}

module.exports = OrganisationPGAdapter
